import React, { useEffect, useState } from "react";
import DateRangeBox from "devextreme-react/date-range-box";
import "devextreme/dist/css/dx.light.css";
import { Box } from "@mui/material";
import "./DateRange.css";
import { LABELS, PLACEHOLDER } from "../../constants";
import { useTranslation } from "react-i18next";

const DateRange = ({ selectedRange, setSelectedRange, selectedDateRange, setSelectedDateRange }) => {
	const [isManualChange, setIsManualChange] = useState(false);
	const { t } = useTranslation();

	const normalizeDateValue = (value) => {
		if (!value) {
			return null;
		}

		if (value instanceof Date) {
			return Number.isNaN(value.getTime()) ? null : value;
		}

		if (typeof value?.toDate === "function") {
			const parsedDate = value.toDate();
			return parsedDate instanceof Date && !Number.isNaN(parsedDate.getTime()) ? parsedDate : null;
		}

		const parsedDate = new Date(value);
		return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
	};

	const formatDate = (value) => {
		const normalizedDate = normalizeDateValue(value);
		if (!normalizedDate) {
			return "";
		}
		return normalizedDate.toLocaleDateString();
	};

	const normalizedSelectedDateRange = Array.isArray(selectedDateRange)
		? selectedDateRange.map((value) => normalizeDateValue(value))
		: null;

	const handleDateChange = (e) => {
		const nextDateRange = Array.isArray(e.value) ? e.value.map((value) => normalizeDateValue(value)) : null;
		setSelectedDateRange(nextDateRange);

		if (isManualChange) {
			setSelectedRange({
				key: "Custom",
				label: t('LABELS.CUSTOM'),
				startDate: formatDate(nextDateRange?.[0]),
				endDate: formatDate(nextDateRange?.[1]),
			});
		}
	};

	const handleOpen = () => {
		setIsManualChange(true);
	};

	const handleClose = () => {
		setIsManualChange(false);
	};

	return (
		<DateRangeBox
			value={normalizedSelectedDateRange}
			onValueChanged={handleDateChange}
			onOpened={handleOpen}
			onClosed={handleClose}
			applyValueMode="useButtons"
			type="date"
			placeholder={t('PLACEHOLDER.SELECE_DATE_RANGE')}
			style={{
				marginTop: "0px",
				width: "100%",
				maxWidth: "300px",
			}}
		/>
	);
};

export default DateRange;
